import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(confirmEmailOnEnterSaga);

import { call } from 'redux-saga/effects';
import { gtmSafeRedirect } from 'redux/saga/helpers';
import { writeLocalStorage } from 'redux/saga/helpers/local-storage';
export function confirmEmailOnEnterSaga(client, nextState) {
  var cookieValue, result;
  return regeneratorRuntime.wrap(function confirmEmailOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(__SERVER__ && !__TEST__)) {
            _context.next = 2;
            break;
          }

          return _context.abrupt("return");

        case 2:
          cookieValue = 'update_email_failure';
          _context.prev = 3;
          _context.next = 6;
          return call(client.users.confirmEmailToken, nextState.params.key);

        case 6:
          result = _context.sent;
          cookieValue = result.email;
          _context.next = 12;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);

        case 12:
          _context.next = 14;
          return call(writeLocalStorage, 'cpChangeEmail', cookieValue);

        case 14:
          _context.next = 16;
          return call(gtmSafeRedirect, '/settings/account');

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 10]]);
}